import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";

import S from "./ActivityRequestCard.module.scss";

export const ActivityRequestCardSkeleton = () => {
  const header = (
    <div className={S.cardHeader}>
      <Skeleton width="80px" height="24px" borderRadius="16px" />
      <div className="text-right">
        <Skeleton width="100px" height="16px" className="mb-1 ml-auto" />
        <Skeleton width="140px" height="12px" className="ml-auto" />
      </div>
    </div>
  );

  const footer = <Skeleton width="110px" height="32px" borderRadius="4px" />;

  return (
    <Card
      className={S.activityCard}
      header={header}
      footer={footer}
      pt={{
        body: { className: "h-full flex flex-col" },
        content: { className: "flex flex-col flex-1 p-0" },
        footer: { className: S.cardFooter },
      }}
    >
      <Skeleton width="90%" height="20px" className="mb-2" />
      <Skeleton width="100%" height="16px" className="mb-1" />
      <Skeleton width="75%" height="16px" className="mb-2" />
      <div className="flex-1"></div>
      <div className="body-sm text-muted mb-2 pt-2">
        <div className="flex flex-wrap gap-2 align-items-center">
          <Skeleton width="100px" height="28px" borderRadius="16px" />
        </div>
      </div>
    </Card>
  );
};
